import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus, HelpCircle } from 'lucide-react';
const faqs = [{
  question: '¿Para quién es exactamente este libro?',
  answer: 'Este libro está diseñado para mujeres que sienten que cargan con heridas del pasado, que luchan con su autoestima o que simplemente desean establecer una relación más sana y amorosa consigo mismas. Es para ti si buscas herramientas prácticas para sanar tu niña interior.'
}, {
  question: '¿En qué formato recibo el material?',
  answer: 'Recibirás el libro principal y todos los bonos de regalo en formato PDF de alta calidad. Esto te permite leerlos en cualquier dispositivo (celular, tablet, tablet o computadora) e incluso imprimirlos si prefieres el papel.'
}, {
  question: '¿Cómo recibo el acceso después de comprar?',
  answer: 'El acceso es inmediato. Una vez confirmado el pago, recibirás un correo electrónico automático con el enlace de descarga para que puedas empezar tu proceso de sanación hoy mismo.'
}, {
  question: '¿Por cuánto tiempo tendré acceso al material?',
  answer: 'El acceso es de por vida. Una vez que descargas los archivos, son tuyos para siempre. Además, tendrás acceso gratuito a todas las futuras actualizaciones que realicemos del material.'
}, {
  question: '¿Necesito conocimientos previos de psicología?',
  answer: 'No, para nada. El libro está escrito en un lenguaje sencillo, cercano y empático. Las herramientas están explicadas paso a paso para que cualquier mujer pueda aplicarlas en su vida cotidiana sin importar su formación previa.'
}, {
  question: '¿Es seguro el pago y qué pasa si no es lo que esperaba?',
  answer: 'Tu pago es 100% seguro y está procesado por plataformas líderes. Además, cuentas con nuestra garantía de satisfacción de 14 días. Si sientes que el material no es para ti, te devolvemos tu dinero sin preguntas.'
}, {
  question: '¿Incluye acompañamiento personalizado?',
  answer: 'El libro es una guía de auto-aplicación diseñada para que puedas realizar el proceso a tu propio ritmo. Sin embargo, dentro del material encontrarás ejercicios de reflexión que te guiarán de la mano en cada etapa de tu sanación.'
}];
export function FAQ() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  return <section className="py-24 pt-[30px] pb-[30px] bg-[#FEFEFE]" data-id="element-54">
      <div className="max-w-3xl mx-auto px-4 bg-[#FEFEFE]" data-id="element-55">
        <div className="text-center mb-16" data-id="element-56">
          <h2 className="text-violet-600 font-black uppercase tracking-[0.3em] mb-4 text-xs" data-id="element-57">
            DESPEJA TUS DUDAS
          </h2>
          <h3 className="text-4xl md:text-6xl text-violet-950 font-medium font-['Playfair_Display']" data-id="element-58">
            Preguntas Frecuentes
          </h3>
        </div>

        <div className="space-y-4" data-id="element-59">
          {faqs.map((faq, index) => <div key={index} className="border border-violet-100 rounded-2xl overflow-hidden transition-all duration-300 hover:border-violet-200" data-id="element-60">
              <button onClick={() => setActiveIndex(activeIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-violet-50/30 hover:bg-violet-50 transition-colors" data-id="element-61">
                <span className="font-bold text-violet-950 pr-8 leading-tight" data-id="element-62">
                  {faq.question}
                </span>
                <div className="shrink-0 text-violet-600" data-id="element-63">
                  {activeIndex === index ? <Minus size={20} data-id="element-64" /> : <Plus size={20} data-id="element-65" />}
                </div>
              </button>

              <AnimatePresence data-id="element-66">
                {activeIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-67">
                    <div className="p-6 pt-0 text-violet-800/80 leading-relaxed bg-violet-50/30" data-id="element-68">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}